import React from "react";

import {
  DataTableSkeleton,
  SectionCardSkeleton,
  SkeletonBlock,
} from "components/admin/loading";
import { SchoolMatchWeekHighlightsSkeleton } from "components/admin/school/school-match-week-highlights";
import {
  SchoolTeamProfileHeroRow,
  SchoolTeamProfileMetadataGrid,
  SchoolTeamProfileOverviewStack,
} from "pages/app/workspace/styles/school-team-profile.page.inline.styles";
import {
  TeamRosterAddPanel,
  TeamRosterAddToolbar,
} from "pages/app/workspace/sections/styles/school-team-section-forms.inline.styles";

export const SchoolTeamOverviewTabSkeleton: React.FC = () => (
  <SchoolTeamProfileOverviewStack aria-label="Loading team overview" role="status">
    <SectionCardSkeleton subtitleWidthClassName="w-56" titleWidthClassName="w-36">
      <div className="space-y-5">
        <div className="rounded-[1.75rem] border border-[var(--brand-border)] bg-[var(--brand-hero-surface)] p-5">
          <SchoolTeamProfileHeroRow>
            <SkeletonBlock className="h-16 w-16 shrink-0 rounded-[22px] sm:h-20 sm:w-20" />
            <div className="min-w-0 flex-1 space-y-3">
              <SkeletonBlock className="h-3 w-24 rounded-full" />
              <SkeletonBlock className="h-8 w-48 max-w-full rounded-[18px]" />
              <SkeletonBlock className="h-4 w-64 max-w-full rounded-full" />
              <div className="flex flex-wrap gap-2">
                <SkeletonBlock className="h-7 w-20 rounded-full" />
                <SkeletonBlock className="h-7 w-24 rounded-full" />
              </div>
            </div>
          </SchoolTeamProfileHeroRow>
        </div>

        <SchoolTeamProfileMetadataGrid>
          {Array.from({ length: 5 }).map((_, index) => (
            <div className="brand-panel-muted rounded-[18px] px-4 py-3.5" key={index}>
              <SkeletonBlock className="h-3 w-20 rounded-full" />
              <SkeletonBlock className="mt-3 h-5 w-28 rounded-full" />
            </div>
          ))}
        </SchoolTeamProfileMetadataGrid>
      </div>
    </SectionCardSkeleton>

    <SchoolMatchWeekHighlightsSkeleton
      showTeamOfTheWeek={false}
      subtitle="Loading match week context..."
      title="Match Week"
    />
  </SchoolTeamProfileOverviewStack>
);

export const SchoolTeamRosterTabSkeleton: React.FC = () => (
  <SectionCardSkeleton subtitleWidthClassName="w-64" titleWidthClassName="w-24">
    <div className="space-y-6">
      <TeamRosterAddPanel aria-label="Loading roster assignment panel" role="status">
        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-36 rounded-full" />
          <div className="flex flex-wrap gap-2">
            <SkeletonBlock className="h-7 w-24 rounded-full" />
            <SkeletonBlock className="h-7 w-28 rounded-full" />
            <SkeletonBlock className="h-7 w-20 rounded-full" />
          </div>
          <SkeletonBlock className="h-4 w-56 max-w-full rounded-full" />
        </div>
        <TeamRosterAddToolbar>
          <div className="min-w-0 flex-1 space-y-2">
            <SkeletonBlock className="h-3 w-16 rounded-full" />
            <SkeletonBlock className="h-[3.35rem] w-full rounded-2xl" />
          </div>
          <SkeletonBlock className="h-[3.35rem] w-full rounded-2xl sm:w-36" />
        </TeamRosterAddToolbar>
      </TeamRosterAddPanel>

      <DataTableSkeleton columns={4} rows={4} showThumbnail />
    </div>
  </SectionCardSkeleton>
);

export const SchoolTeamActivityTabSkeleton: React.FC = () => (
  <SchoolTeamProfileOverviewStack aria-label="Loading team activity" role="status">
    <SectionCardSkeleton subtitleWidthClassName="w-48" titleWidthClassName="w-40">
      <DataTableSkeleton columns={3} rows={4} showThumbnail />
    </SectionCardSkeleton>
    <SectionCardSkeleton subtitleWidthClassName="w-52" titleWidthClassName="w-44">
      <DataTableSkeleton columns={4} rows={3} />
    </SectionCardSkeleton>
  </SchoolTeamProfileOverviewStack>
);

export const SchoolTeamProfileTabSkeleton: React.FC = () => (
  <SectionCardSkeleton subtitleWidthClassName="w-56" titleWidthClassName="w-40">
    <SkeletonBlock className="h-56 w-full rounded-[24px]" />
  </SectionCardSkeleton>
);
